import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { eventTypes } from "../data/brand";
import { LuxButton } from "./LuxButton";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
  "w-full bg-transparent border-b border-white/20 py-3 text-white placeholder:text-white/30 text-sm font-light tracking-wide focus:outline-none focus:border-[#C1272D] transition-colors";

export const EventForm = ({ dark = true }) => {
  const [form, setForm] = useState({
    name: "", email: "", phone: "", event_date: "", guests: "", event_type: "", details: "",
  });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.phone) {
      toast.error("Please add your name, email and phone.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/event-inquiries`, { ...form, brand: "river-stone" });
      toast.success("Inquiry Demonstration Complete — in production, this inquiry would be routed directly to River Stone's private-events team.", { duration: 6000 });
      setForm({ name: "", email: "", phone: "", event_date: "", guests: "", event_type: "", details: "" });
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="event-inquiry-form" className="space-y-6">
      <div className="grid sm:grid-cols-2 gap-6">
        <input data-testid="event-name" aria-label="Name" className={inputCls} placeholder="Name" value={form.name} onChange={set("name")} />
        <input data-testid="event-email" aria-label="Email" type="email" className={inputCls} placeholder="Email" value={form.email} onChange={set("email")} />
        <input data-testid="event-phone" aria-label="Phone" className={inputCls} placeholder="Phone" value={form.phone} onChange={set("phone")} />
        <input data-testid="event-date" aria-label="Preferred Event Date" className={inputCls} placeholder="Preferred Event Date" onFocus={(e) => (e.target.type = "date")} onBlur={(e) => !e.target.value && (e.target.type = "text")} value={form.event_date} onChange={set("event_date")} />
        <input data-testid="event-guests" aria-label="Number of Guests" type="number" min="1" className={inputCls} placeholder="Number of Guests" value={form.guests} onChange={set("guests")} />
        <select data-testid="event-type" aria-label="Event Type" className={`${inputCls} appearance-none cursor-pointer`} value={form.event_type} onChange={set("event_type")}>
          <option value="" className="bg-[#161412]">Event Type</option>
          {eventTypes.map((t) => <option key={t} value={t} className="bg-[#161412]">{t}</option>)}
        </select>
      </div>
      <textarea data-testid="event-details" aria-label="Additional Details" rows={3} className={`${inputCls} resize-none`} placeholder="Additional Details" value={form.details} onChange={set("details")} />
      <div className="pt-2">
        <LuxButton type="submit" variant="gold" testid="event-submit" onClick={() => {}}>
          {loading ? "Sending…" : "Start Planning"}
        </LuxButton>
      </div>
    </form>
  );
};
